import { jsx as _jsx } from "react/jsx-runtime";
import { LabeledSelect } from '@/shared/ui';
import { uiCopy } from '@/shared/copy';
import { MANUAL_EXTERNAL_RATING_OPTIONS, parseManualExternalRating, } from '../model/external-rating';
export function ExternalRatingField({ value, onChange, disabled, required, id = 'external-rating', }) {
    return (_jsx(LabeledSelect, { id: id, label: uiCopy.agentCardRatingExternal, value: value == null ? '' : String(value), onValueChange: (next) => onChange(parseManualExternalRating(next)), options: [
            {
                value: '',
                label: required
                    ? uiCopy.externalRatingPick
                    : uiCopy.externalRatingUnset,
            },
            ...MANUAL_EXTERNAL_RATING_OPTIONS,
        ], disabled: disabled, "aria-label": uiCopy.agentCardRatingExternal, "aria-required": required || undefined }));
}
